<div class="portfolio-report-card">
    <div class="row">
        <div class="col-12 col-sm-6 col-md-6 col-lg-8 col-xl-12">
            <div class="card-title" i18n>Find out more about your Portfolio</div>
            <div class="long-card-version card-subtext" i18n>
                Gain valuable insight into how your portfolio and customers are performing.
            </div>
            <!-- info box xs, xl -->
            <div class="short-card-version insights-card-wrapper">
                <div class="insights-card">
                    <div>
                        <div class="insights-bullet-container">
                            <div class="insights-bullet-outer-wrapper">
                                <div class="insights-bullet"></div>
                            </div>
                        </div>
                        <div class="insights-card-text" i18n>Industry Benchmarking</div>
                    </div>
                    <div>
                        <div class="insights-bullet-container">
                            <div class="insights-bullet-outer-wrapper">
                                <div class="insights-bullet"></div>
                            </div>
                        </div>
                        <div class="insights-card-text" i18n>Customer Performance</div>
                    </div>
                    <div>
                        <div class="insights-bullet-container">
                            <div class="insights-bullet-outer-wrapper">
                                <div class="insights-bullet"></div>
                            </div>
                        </div>
                        <div class="insights-card-text" i18n>
                            Aging Trends, <strong>& more...</strong>
                        </div>
                    </div>
                </div>
            </div>
            <lsq-button
                appearance="primary"
                (buttonClick)="downloadReport()"
                [disabled]="
                    !(creditReportFeatureFlag$ | async) ||
                    !(canDownloadInsightsReportData$ | async)?.isValidClient
                "
                [submitting]="this.reportIsLoading"
                class="get-report-btn"
                i18n="Get Your Report button"
            >
                Get Your Report
            </lsq-button>
        </div>
        <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-12 long-card-version">
            <!-- info box sm, md, lg -->
            <div class="long-card-version insights-card-wrapper">
                <div class="insights-card">
                    <div>
                        <div class="insights-bullet-container">
                            <div class="insights-bullet-outer-wrapper">
                                <div class="insights-bullet"></div>
                            </div>
                        </div>
                        <div class="insights-card-text" i18n>Industry Benchmarking</div>
                    </div>
                    <div>
                        <div class="insights-bullet-container">
                            <div class="insights-bullet-outer-wrapper">
                                <div class="insights-bullet"></div>
                            </div>
                        </div>
                        <div class="insights-card-text" i18n>Customer Performance</div>
                    </div>
                    <div>
                        <div class="insights-bullet-container">
                            <div class="insights-bullet-outer-wrapper">
                                <div class="insights-bullet"></div>
                            </div>
                        </div>
                        <div class="insights-card-text" i18n>Changes in DSO</div>
                    </div>
                    <div>
                        <div class="insights-bullet-container">
                            <div class="insights-bullet-outer-wrapper">
                                <div class="insights-bullet"></div>
                            </div>
                        </div>
                        <div class="insights-card-text" i18n>Monthly Sales</div>
                    </div>
                    <div>
                        <div class="insights-bullet-container">
                            <div class="insights-bullet-outer-wrapper">
                                <div class="insights-bullet"></div>
                            </div>
                        </div>
                        <div class="insights-card-text" i18n>
                            Aging Trends, <strong>& more...</strong>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
